import Container from '@mui/material/Container';
import { styled } from '@mui/material';

const CustomContainer = styled(Container)(() => ({
  backgroundColor: "white",
  borderRadius: "40px",
  boxShadow: "0px 0px 15px 0px rgb(88 88 88 / 20%)",
  padding: "12px 24px",
  margin: "auto !important",
}));

export default CustomContainer;